import { configureStore } from "@reduxjs/toolkit";
import combineReducer from "./combineReducer";
import hubMiddleware from "../components/realtime/hubMiddleware";

export default function configureAppStore(state) {
  return configureStore({
    reducer: combineReducer,
    preloadedState: state,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types for serializable check
          ignoredActions: [
            'HUB_CONNECTION_CREATED',
            'HUB_CONNECTION_CLOSED',
            'AUTHENTICATE_THE_USER_TRUE',
            'AUTHENTICATE_THE_USER_FALSE'
          ],
          // Ignore these field paths in all actions
          ignoredActionPaths: [
            'payload.hubConnection',
            'payload'
          ],
          // Ignore these paths in the state
          ignoredPaths: ['accountReducer.hubConnection'],
        },
        // Disable mutation check entirely to allow hub connection mutations
        immutableCheck: false,
      }).concat(hubMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  });
}
